
export { Icons } from "/home/runner/work/stackd-perps/stackd-perps/packages/vertex-ui/components/Icons/icons.tsx"